import { render, staticRenderFns } from "./AddOtherTask.vue?vue&type=template&id=25c81132&scoped=true"
import script from "./AddOtherTask.vue?vue&type=script&lang=js"
export * from "./AddOtherTask.vue?vue&type=script&lang=js"
import style0 from "./AddOtherTask.vue?vue&type=style&index=0&id=25c81132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c81132",
  null
  
)

export default component.exports